import { COMPLIANCE_REPORT_PATH, useComplianceReportRoute } from './router';
import { Routes, Route } from 'react-router-dom';
import { Router } from 'framework/routing';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import ComplianceReportListPage from './List/ComplianceReportListPage';
import { GlobalProtectedRoute } from 'framework/authorization';
import { READ_COMPLIANCE_REGISTRY_DOCUMENTS, ComplianceDocumentContext } from 'domain/shared/compliance';

const ComplianceReportRouter: Router = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useComplianceReportRoute();
  return (
    <Routes>
      <Route
        path={listRoute}
        element={
          <GlobalProtectedRoute globalPermissionToCheck={[READ_COMPLIANCE_REGISTRY_DOCUMENTS]}>
            <ComplianceDocumentContext>
              <ComplianceReportListPage />
            </ComplianceDocumentContext>
          </GlobalProtectedRoute>
        }
      />
      <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
    </Routes>
  );
};

ComplianceReportRouter.getRouterPath = () => `${COMPLIANCE_REPORT_PATH}/*`;

export default ComplianceReportRouter;
